export function CountColumn({ columns }) {
  return columns["COUNT"];
}
